import FileUpload from 'library/components/form/add-image';
import withFormContainer from 'library/components/modal/hocs/with-form-container';

export default withFormContainer(FileUpload);
